export default (api, resource) => ({

  getAll: async ({ token }) => {
    const response = await api.get(`/${resource}`, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  getAdjustments: async ({ vendorId, page, perPage, token }) => {
    const response = await api.get(`/${resource}/${vendorId}/adjustments?page=${page}&perPage=${perPage}`, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

  // o operador informa o saldo real; `expectedBalance` é o saldo que ele viu na tela, e o
  // backend recusa com 409 se o saldo mudou nesse meio-tempo
  adjust: async ({ vendorId, balance, expectedBalance, reason, token }) => {
    const response = await api.post(`/${resource}/${vendorId}/adjustments`, {
      balance,
      expected_balance: expectedBalance,
      reason
    }, {
      headers: {
        Authorization: token
      }
    })

    return {
      data: response.data
    }
  },

})
